import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  headerTitle: '',
  filter: '',
  tab: '',
  pathname: '',
  miniHeaderActions: {
    editEnabled: false,
    approveEnabled: false,
    declineEnabled: false,
    removeEnabled: false,
  },
  miniHeaderEvents: {
    editClick: false,
    declineClick: false,
    approveClick: false,
  },
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setHeaderTitle: (state, action) => {
      state.headerTitle = action.payload
    },
    setFilter: (state, action) => {
      state.filter = action.payload
    },
    setTab: (state, action) => {
      state.tab = action.payload
    },
    setPathname: (state, action) => {
      state.pathname = action.payload
    },
    setMiniHeaderState: (state, action) => {
      const { headerTitle, filter, pathname, tab } = action.payload
      if (headerTitle !== undefined) state.headerTitle = headerTitle
      if (filter !== undefined) state.filter = filter
      if (pathname !== undefined) state.pathname = pathname
      if (tab !== undefined) state.tab = tab
    },
    setMiniHeaderActions: (state, action) => {
      state.miniHeaderActions = { ...state.miniHeaderActions, ...action.payload }
    },
    triggerMiniHeaderEvent: (state, action) => {
      const { eventName } = action.payload
      if (state.miniHeaderEvents[eventName] !== undefined) {
        state.miniHeaderEvents[eventName] = true
      }
    },
    clearMiniHeaderEvents: state => {
      state.miniHeaderEvents = {
        editClick: false,
        declineClick: false,
        approveClick: false,
      }
    },
  },
})

export const {
  setHeaderTitle,
  setFilter,
  setTab,
  setPathname,
  setMiniHeaderState,
  setMiniHeaderActions,
  triggerMiniHeaderEvent,
  clearMiniHeaderEvents,
} = uiSlice.actions

export default uiSlice.reducer
